"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformTasksRequest = exports.transformTasksParsedResponse = exports.transformTasksListResponse = exports.transformTasksResponse = void 0;
/* eslint-disable @typescript-eslint/camelcase */
const Error_1 = require("./Error");
const Money_1 = require("./Money");
function transformTasksResponse(data, headers, status) {
    const response = JSON.parse(data);
    if ((0, Error_1.isAccountingErrorResponse)(status, response)) {
        return (0, Error_1.transformAccountingErrorResponse)(response);
    }
    const { task } = response.response.result;
    return transformTasksParsedResponse(task);
}
exports.transformTasksResponse = transformTasksResponse;
function transformTasksListResponse(data, headers, status) {
    const response = JSON.parse(data);
    if ((0, Error_1.isAccountingErrorResponse)(status, response)) {
        return (0, Error_1.transformAccountingErrorResponse)(response);
    }
    const { tasks, per_page, total, page, pages } = response.response.result;
    return {
        tasks: tasks.map((task) => transformTasksParsedResponse(task)),
        pages: {
            total,
            size: per_page,
            pages,
            page,
        },
    };
}
exports.transformTasksListResponse = transformTasksListResponse;
function transformTasksParsedResponse(task) {
    return {
        id: task.id,
        billable: task.billable,
        description: task.description,
        name: task.name,
        rate: task.rate,
        taskid: task.taskid,
        tname: task.tname,
        tdesc: task.tdesc,
        visState: task.visState,
        updated: task.updated,
    };
}
exports.transformTasksParsedResponse = transformTasksParsedResponse;
function transformTasksRequest(task) {
    return JSON.stringify({
        task: {
            id: task.id,
            billable: task.billable,
            description: task.description,
            name: task.name,
            rate: task.rate && (0, Money_1.transformMoneyParsedRequest)(task.rate),
            taskid: task.taskid,
            tname: task.tname,
            tdesc: task.tdesc,
            visState: task.visState,
            updated: task.updated,
        },
    });
}
exports.transformTasksRequest = transformTasksRequest;
//# sourceMappingURL=Tasks.js.map